export default __webpack_public_path__ + "static/media/annex1.0321f3d9.png";